import React from 'react';
import Widget from 'components/Widget/Widget';
import NetworKChartContent from './components/NetworKChartContent';
import { metricsList } from '../components/metricsList';

const NetworkReportsChart = (props) => {
  const { data, index, height = 500, configuration } = props;

  return (
    <Widget
      className='h-full'
      widget_key={data?.defaultFilter?.network + 'chart' + index}
      title={data.title}
      index={index}
      disableLimit
      disableStatusFilter
      disableLevelFilter
      data={data}
      default_filter={data?.defaultFilter}
      icon={
        data?.defaultFilter?.network && (
          <img src={`/icons/networks/${data?.defaultFilter?.network}.svg`} className='w-7 h-7 ' />
        )
      }
      networkSwitch={false}
      network={data?.defaultFilter?.network}
      configuration={configuration}
      metricsList={metricsList}
      load_chart={true}
      adsFilter
      adsetFilter
      campaignFilter
      showCustomDesign
      changeMetricsDesign
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <NetworKChartContent height={height - 55} data={data} />
    </Widget>
  );
};

export default NetworkReportsChart;
